<template>
  <div class="tc-shell" style="margin-top: 20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 20px; padding: 4px 12px;">
      <span style="font-size: 26px; font-weight: bold">Settings</span>
    </div>

    <div class="tc-layout">

      <!-- Collapseable left nav -->
      <div class="tc-nav-wrapper" :class="{ 'tc-nav-collapsed': navCollapsed }">
        <div class="tc-nav-inner">
          <button
            v-for="tab in visibleTabs"
            :key="tab.id"
            class="tc-nav-item"
            :class="{ active: activeTab === tab.id }"
            @click="selectTab(tab.id)"
          >
            {{ tab.label }}
          </button>
        </div>
        <button
          class="tc-nav-toggle"
          @click="navCollapsed = !navCollapsed"
          :title="navCollapsed ? 'Expand menu' : 'Collapse menu'"
          :aria-label="navCollapsed ? 'Expand menu' : 'Collapse menu'"
        >
          <i class="fa" :class="navCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
        </button>
      </div>

      <!-- Tab content -->
      <div class="tc-content">

        <tenant-config-general
          v-show="activeTab === 'tab_general'"
          ref="tab_general"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-bookings-actuals
          v-if="showBookingsActuals"
          v-show="activeTab === 'tab_bookings_actuals'"
          ref="tab_bookings_actuals"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-cust-map-views
          v-show="activeTab === 'tab_cust_map_views'"
          ref="tab_cust_map_views"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-views-reports
          v-if="showViewsReports"
          v-show="activeTab === 'tab_views_reports'"
          ref="tab_views_reports"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-alerts
          v-if="showAlerts"
          v-show="activeTab === 'tab_alerts'"
          ref="tab_alerts"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-notifications
          v-if="showNotifications"
          v-show="activeTab === 'tab_notifications'"
          ref="tab_notifications"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-veh-status-mgmt
          v-if="showVSM"
          v-show="activeTab === 'tab_veh_status_mgmt'"
          ref="tab_veh_status_mgmt"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-bus-sos
          v-if="showBusSOS"
          v-show="activeTab === 'tab_bus_sos'"
          ref="tab_bus_sos"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-data-services
          v-if="showDataServices"
          v-show="activeTab === 'tab_data_services'"
          ref="tab_data_services"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-fleet-assistant
          v-if="showFleetAssistant"
          v-show="activeTab === 'tab_fleet_assistant'"
          ref="tab_fleet_assistant"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <tenant-config-history
          v-show="activeTab === 'tab_history'"
          ref="tab_history"
          @showAlert="$emit('showAlert', ...arguments)"
        />

        <user-list
          v-show="activeTab === 'tab_user_list'"
          ref="tab_user_list"
        />

      </div>
    </div>

    <b-modal
      id="tc-unsaved-modal"
      title="Unsaved Changes"
      ok-title="Leave without saving"
      cancel-title="Stay on this page"
      ok-variant="danger"
      @ok="confirmTabSwitch"
      @cancel="cancelTabSwitch"
      @hide="onUnsavedModalHide"
    >
      <p>You have unsaved changes on this page. If you continue, your changes will be lost.</p>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import TenantConfigGeneral from './tenant_config_general.vue'
import TenantConfigBookingsActuals from './tenant_config_bookings_actuals.vue'
import TenantConfigCustMapViews from './tenant_config_cust_map_views.vue'
import TenantConfigViewsReports from './tenant_config_views_reports.vue'
import TenantConfigAlerts from './tenant_config_alerts.vue'
import TenantConfigNotifications from './tenant_config_notifications.vue'
import TenantConfigVehStatusMgmt from './tenant_config_veh_status_mgmt.vue'
import TenantConfigBusSos from './tenant_config_bus_sos.vue'
import TenantConfigDataServices from './tenant_config_data_services.vue'
import TenantConfigFleetAssistant from './tenant_config_fleet_assistant.vue'
import TenantConfigHistory from './tenant_config_history.vue'
import UserList from './user_list.vue'

const TAB_LABELS = {
  tab_general:          'General',
  tab_bookings_actuals: 'Bookings & Actuals',
  tab_cust_map_views:   'Map Settings',
  tab_views_reports:    'Views & Reports',
  tab_alerts:           'Alerts',
  tab_notifications:    'Notifications',
  tab_veh_status_mgmt:  'Vehicle Status Mgr',
  tab_bus_sos:          'Bus SOS Settings',
  tab_sos_manager:      'Bus SOS Manager',
  tab_data_services:    'Data Services',
  tab_fleet_assistant:  'Fleet Assistant',
  tab_history:          'History',
  tab_user_list:        'Manage Users',
}

export default {
  name: 'tenant_config_shell',
  components: {
    TenantConfigGeneral,
    TenantConfigBookingsActuals,
    TenantConfigCustMapViews,
    TenantConfigViewsReports,
    TenantConfigAlerts,
    TenantConfigNotifications,
    TenantConfigVehStatusMgmt,
    TenantConfigBusSos,
    TenantConfigDataServices,
    TenantConfigFleetAssistant,
    TenantConfigHistory,
    UserList,
  },
  data() {
    return {
      activeTabIndex: 0,
      pendingTabIndex: null,
      pendingNavNext: null,
      modalOkClicked: false,
      navCollapsed: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.anyTabDirty) {
      this.pendingNavNext = next
      this.pendingTabIndex = null
      this.modalOkClicked = false
      this.$bvModal.show('tc-unsaved-modal')
    } else {
      next()
    }
  },
  mounted() {
    this._beforeUnloadHandler = (e) => {
      if (this.anyTabDirty) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', this._beforeUnloadHandler)

    this._onResize = () => {
      if (window.innerWidth < 1240) this.navCollapsed = true
    }
    window.addEventListener('resize', this._onResize)
    this._onResize()

    const saved = localStorage.getItem('tc_active_tab')
    if (saved) {
      const idx = this.visibleTabRefKeys.indexOf(saved)
      if (idx !== -1) this.activeTabIndex = idx
    }
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this._beforeUnloadHandler)
    window.removeEventListener('resize', this._onResize)
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    showBookingsActuals() {
      return this.user.role === 'admin' || this.user.features[this.user.tenant].actuals_enabled
    },
    showViewsReports() {
      return this.user.role === 'admin' || this.user.features[this.user.tenant].views_reports_enabled
    },
    showAlerts() {
      return this.user.role === 'admin' || this.user.features[this.user.tenant].alerts_enabled
    },
    showNotifications() {
      return this.user.role === 'admin' || this.user.features[this.user.tenant].alerts_enabled
    },
    showVSM() {
      return this.user.role === 'admin' || this.user.features[this.user.tenant].vehicle_status_management_enabled
    },
    showBusSOS() {
      return this.isEffectiveAdmin || this.user.features[this.user.tenant].bus_sos_enabled
    },
    showDataServices() {
      return this.user.role === 'admin' || this.user.features[this.user.tenant].data_services_enabled
    },
    showFleetAssistant() {
      return this.user.role === 'admin' || (this.user.tenant === 'anderson-759g468f' && this.user.role === 'customer-admin')
    },
    visibleTabRefKeys() {
      const keys = ['tab_general']
      if (this.showBookingsActuals) keys.push('tab_bookings_actuals')
      keys.push('tab_cust_map_views')
      if (this.showViewsReports) keys.push('tab_views_reports')
      if (this.showAlerts) keys.push('tab_alerts')
      if (this.showNotifications) keys.push('tab_notifications')
      if (this.showVSM) keys.push('tab_veh_status_mgmt')
      if (this.showBusSOS) keys.push('tab_sos_manager')
      if (this.showBusSOS) keys.push('tab_bus_sos')
      if (this.showDataServices) keys.push('tab_data_services')
      if (this.showFleetAssistant) keys.push('tab_fleet_assistant')
      keys.push('tab_history')
      keys.push('tab_user_list')
      return keys
    },
    visibleTabs() {
      return this.visibleTabRefKeys.map(id => ({ id, label: TAB_LABELS[id] }))
    },
    activeTab() {
      return this.visibleTabRefKeys[this.activeTabIndex] || null
    },
    anyTabDirty() {
      return this.visibleTabRefKeys.some(key => {
        const ref = this.$refs[key]
        return ref && ref.isDirty
      })
    },
  },
  methods: {
    selectTab(id) {
      if (id === 'tab_sos_manager') {
        this.$router.push({ name: 'sos_list' })
        return
      }
      if (this._confirmingTabSwitch) return
      const newIndex = this.visibleTabRefKeys.indexOf(id)
      if (newIndex === this.activeTabIndex) return
      const prevRef = this.$refs[this.activeTab]
      if (prevRef && prevRef.isDirty) {
        this.pendingTabIndex = newIndex
        this.modalOkClicked = false
        this.$bvModal.show('tc-unsaved-modal')
      } else {
        this.activeTabIndex = newIndex
        localStorage.setItem('tc_active_tab', id)
      }
    },
    confirmTabSwitch() {
      this.modalOkClicked = true
      if (this.pendingNavNext) {
        const next = this.pendingNavNext
        this.pendingNavNext = null
        next()
      } else {
        const prevRef = this.$refs[this.activeTab]
        if (prevRef && prevRef.isDirty) {
          prevRef.load_data()
        }
        this._confirmingTabSwitch = true
        this.activeTabIndex = this.pendingTabIndex
        localStorage.setItem('tc_active_tab', this.visibleTabRefKeys[this.pendingTabIndex])
        this.pendingTabIndex = null
        this.$nextTick(() => { this._confirmingTabSwitch = false })
      }
    },
    cancelTabSwitch() {
      if (this.pendingNavNext) {
        const next = this.pendingNavNext
        this.pendingNavNext = null
        next(false)
      }
      this.pendingTabIndex = null
      const correctIndex = this.activeTabIndex
      setTimeout(() => {
        const focusedEl = document.activeElement
        if (focusedEl && this.$el.contains(focusedEl)) {
          focusedEl.blur()
        }
        const refKey = this.visibleTabRefKeys[correctIndex]
        const ref = refKey ? this.$refs[refKey] : null
        if (ref && ref.scrollToFirstDirtyField) {
          ref.scrollToFirstDirtyField()
        }
      }, 300)
    },
    onUnsavedModalHide() {
      if (!this.modalOkClicked) {
        this.pendingTabIndex = null
      }
      this.modalOkClicked = false
    },
  },
}
</script>

<style scoped>
/* ── Layout ─────────────────────────────────────────────────────────── */
.tc-layout {
  display: flex;
  align-items: flex-start;
}

/* ── Left nav wrapper (handles collapse transition) ─────────────────── */
.tc-nav-wrapper {
  position: relative;
  display: flex;
  flex-shrink: 0;
}

.tc-nav-inner {
  width: 210px;
  min-width: 210px;
  overflow: hidden;
  transition: width 0.22s ease, min-width 0.22s ease;
  background-color: #e8eef5;
  border-right: 2px solid #dee2e6;
  padding: 12px 0;
}

.tc-nav-collapsed .tc-nav-inner {
  width: 0;
  min-width: 0;
  border-right: none;
  padding: 0;
}

/* ── Nav items ──────────────────────────────────────────────────────── */
.tc-nav-item {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  border-bottom: 1px solid #c8d8e8;
  color: #333;
  padding: 10px 16px;
  font-size: 15px;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
  outline: none;
}

.tc-nav-item:last-child {
  border-bottom: none;
}

.tc-nav-item:hover {
  background-color: #d0dfee;
}

.tc-nav-item:hover::before {
  content: '';
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  border: 1px solid #a0b8d0;
  pointer-events: none;
}

.tc-nav-item:focus {
  outline: none;
  box-shadow: none;
}

.tc-nav-item.active {
  background-color: steelblue !important;
  color: white !important;
  font-weight: bold;
  border-bottom: 1px solid #f0f0f0;
  border-right: 3px solid #2e6da4;
}

.tc-nav-item.active::before {
  display: none;
}

/* ── Collapse toggle ────────────────────────────────────────────────── */
.tc-nav-toggle {
  position: absolute;
  top: 12px;
  right: -20px;
  width: 20px;
  height: 36px;
  background: #e8eef5;
  border: 1px solid #c8d8e8;
  border-left: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a6785;
  font-size: 11px;
  padding: 0;
  z-index: 10;
  transition: background 0.15s;
}

.tc-nav-toggle:hover {
  background: #d0dfee;
  color: steelblue;
}

.tc-nav-toggle:focus {
  outline: none;
}

/* ── Content area ───────────────────────────────────────────────────── */
.tc-content {
  flex: 1;
  min-width: 0;
  padding-left: 24px;
}
</style>
